<template>
    <div :class="'h-100 bg-white'">

        <div class="top-agent-wrap">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div>
                            <h4 class="card-title mb-0 title-font">{{$t('dashBoard.cSysAgentSales.topAgent')}}</h4>
                        </div>
                        <div class="ml-auto">
                            <cMonthDropdown
                                    :ctrlName="'monthName'"
                                    :ctrlCode="'month'"
                                    :isAllowEmpty="false"
                                    :isShowCode="false"
                                    :isMultiple="false"
                                    :isSearchable="true"
                                    v-on:input="onPeriodChange"
                                    :selValue="selPeriod"
                                    rules="required"

                            />


                        </div>
                    </div>
                </div>
                <div class="card-body bg-light">
                    <div class="row align-items-center">
                        <div v-if="selPeriod" class="col-xs-12 col-md-6">
                            <h3 class="m-b-0 font-light">{{selPeriod.monthName}} {{selPeriod.year}}</h3>
                            <span class="font-14 text-muted">{{$t('dashBoard.cSysAgentSales.salesReport')}}</span>
                        </div>
                        <div v-if="totalSales"
                             class="col-xs-12 col-md-6 align-self-center display-5 text-info text-right">
                            <div v-for="(sales,index) in totalSales" :key="'sales'+index">
                                {{sales}}
                            </div>
                        </div>
                        <div v-else class="col-xs-12 col-md-6 align-self-center display-6 text-info text-right">
                            0
                        </div>
                    </div>
                </div>
                <div v-if="sysAgentSalesRes" class="table-responsive">
                    <cTable
                            :items="isViewMore?sysAgentSalesRes.AgentwiseSales:frstFewSalesRes"
                            :fields="salesFieldLs"
                            hover
                            :fullScreen="false"
                            class="table  table-hover"
                            @row-clicked="toggleAgentDbPopup"
                    >
                        <!--                sorter-->
                        <template #no-items-view>
                            <div class="text-center my-5">
                                <h3>{{$t('dashBoard.cSysAgentSales.noItemsView')}}</h3>
                            </div>
                        </template>
                        <template #name="{item}">
                            <td>
                                <div v-if="item.agentname">
                                    <div>{{ item.agentname }}</div>
                                </div>
                            </td>
                        </template>
                        <template #price="{item}">
                            <td>
                                <CRow>

                                
                                <div v-if="item.totalsales!='0'">
                                    <div>{{item.currency+' '}}{{Math.round(Number(item.totalsales))|formatNumber(item.currency) }}
                                    </div>
                                </div>
                                <div v-else>
                                    0
                                </div>
                                
                               </CRow>
                            </td>

                            <td>
                                <span>
                                     <div
                    col="1.5"
                    size="sm"
                    color="info removewrap"
                   
                    class=" icon-25px c-pointer"
                  >
                         <img src="@imgPath/img/svg/icons/chart-icon.svg" alt="" width="24px">
<!--                    <CIcon  name="cil-chat" size="lg"></CIcon>-->
                  </div>
                                </span>
                            </td>
                        </template>
                    </cTable>
                
                    <CButton v-if="sysAgentSalesRes.AgentwiseSales.length!=0 && !isViewMore"
                             @click="isViewMore=!isViewMore" class="t-more-btn">{{$t('dashBoard.cSysAgentSales.showMore')}}
                    </CButton>
                    <CButton v-if="sysAgentSalesRes.AgentwiseSales.length!=0 && isViewMore"
                             @click="isViewMore=!isViewMore" class="t-more-btn">{{$t('dashBoard.cSysAgentSales.showLess')}}
                    </CButton>
                </div>
            </div>
        </div>
        <cSysMiniAgentDB v-if="isShowAgentDpModal" @closeDBModal="closeAgtDBModal" :isShowAgentDpModal="isShowAgentDpModal" :selAgent="selAgent"> </cSysMiniAgentDB>
   
    </div>

</template>
<script>

    import Logger from "../../../services/logger";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "@/util/apiValidate.js";
    import router, {navigate, goBack} from "../../../router/index";
    import apiAgentSales from "./../../../services/apiAgentSales";
    import cSysMiniAgentDB from "../system/miniAgentDP/cSysMiniAgentDB";
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../../config/API_DATA";
    import cMonthDropdown from "../../../components/form/cMonthDropdown";
    import {COMPONENT_NAME, PATHNAME, BOOKING_STATUS} from "../../../util/constants";
    import BaseConfiguration from "../../../config/base.js";
    import SERVICE_URL from "../../../config/API_DATA";
    import {mapGetters, mapActions} from "vuex";
    import {handleJWT, getErrorAlertValue, groupBy} from "../../../util/util";
    import cSysBookingNo from "../../../components/dashboard/system/cSysBookingNo";
    import cSysWeeklySale from "../../../components/dashboard/system/cSysWeeklySale";
    import cSysSearchCount from "../../../components/dashboard/system/cSysSearchCount";
    import cTable from "../../../components/dataTable/cTable";

    export default {
        name: COMPONENT_NAME.C_SYS_AGENT_SALES,

        components: {
            cMonthDropdown,
            cSysBookingNo,
            cSysWeeklySale,
            cSysSearchCount,
            cSysMiniAgentDB,
            cTable
        },
        props:{
     
        isAgentGroup:{
            type: Boolean,
            default: false
        }
    },

        data() {
            return {
                frstFewSalesRes: [],
                sysAgentSalesRes: null,
                isViewMore: false,
                totalSales: null,
                selPeriod: null,
                salesFieldLs: [],
                isShowAgentDpModal: false,
                selAgent:null
            }
        },

        computed: {
            ...mapGetters("sSysLogin", {
                ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
            }),
        },
        async created() {
            if (BaseConfiguration.isDebug) console.log("created");
            try {
                if (this.ADMIN_SIGNIN_RES) {
                    this.sysAgentSalesRes = await this.getSysAgentSales();
                    this.totalSales = this.toGetTotalSales(this.sysAgentSalesRes);
                    this.salesFieldLs = this.getDataField();

                }
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_SYS_AGENT_SALES,
                    "error in  Created",
                    err.toString(),
                    " Created()",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },

        methods: {
            showAlert(val) {
                this.$emit("showAlert", val);
            },

            closeAgtDBModal(){
                this.isShowAgentDpModal = false;
            },

            toggleAgentDbPopup(pselAgent) {
                this.isShowAgentDpModal = true;
                if(pselAgent){
                    this.selAgent = pselAgent
                }
            },
            getDataField() {
                if (BaseConfiguration.isDebug) console.log("getDataField");
                return [

                    {
                        key: "name",
                        label: this.$t('dashBoard.cSysAgentSales.agencyName'),
                        sorter: false
                    },
                     {
                        key: "b2bcode",
                        label: this.$t('dashBoard.cSysAgentSales.agencyCode'),

                    },
                    {
                        key: "issuedbookings",
                        label: this.$t('dashBoard.cSysAgentSales.issuedBooking'),

                    },

                   
                    {
                        key: "price",
                        label: this.$t('dashBoard.cSysAgentSales.sales'),
                        sorter: false
                    },

                ];
            },

            async onPeriodChange(pSelPeriod) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("onPeriodChange");
                    this.selPeriod = pSelPeriod;
                    this.sysAgentSalesRes = await this.getSysAgentSales();
                    //    if(this.sysAgentSalesRes && this.sysAgentSalesRes.AgentwiseSales) {
//               this.sysAgentSalesRes.AgentwiseSales.push({totalsales: "30328.9651000000",
// issuedbookings: "198",
// b2bid: "127",
// agentname: "New travels",
// b2bcode: "MMCHI00001",
// currency: "MMK"}); 
// this.sysAgentSalesRes.AgentwiseSales=[];
//            }
                    this.totalSales = this.toGetTotalSales(this.sysAgentSalesRes);

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_SYS_AGENT_SALES,
                        "error in onPeriodChange",
                        err.toString(),
                        "onPeriodChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            toGetTotalSales(pSalesObj) {

                let groupedPrice = [];
                let totalPrice = [];
                try {
                    if (BaseConfiguration.isDebug) console.log("toGetTotalSales");
                    if (pSalesObj && (pSalesObj.AgentwiseSales.length != 0)) {
                        this.frstFewSalesRes = [];
                        for (let i = 0; i < pSalesObj.AgentwiseSales.length; i++) {
                            if (i < BaseConfiguration.sys_dashboard_top_agent_max) {
                                this.frstFewSalesRes.push(pSalesObj.AgentwiseSales[i])
                            }
                            pSalesObj.AgentwiseSales[i].issuedbookings = Number(pSalesObj.AgentwiseSales[i].issuedbookings)

                        }
                        groupedPrice.push(groupBy(pSalesObj.AgentwiseSales, "currency"))
                        if (groupedPrice.length != 0) {
                            let priceLs = JSON.parse(JSON.stringify(groupedPrice[0]));
                            for (var index in priceLs) {
                                let retValue = 0;
                                if (priceLs.length != 0) {
                                    for (let j = 0; j < priceLs[index].length; j++) {
                                        retValue += Number(priceLs[index][j].totalsales);
                                    }
                                    retValue = this.$options.filters.formatNumber(retValue, index);
                                    retValue = (retValue != undefined) ? retValue : '0.00';
                                    totalPrice.push(index + ' ' + retValue);
                                }
                            }
                        }
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_SYS_AGENT_SALES,
                        "error in toGetTotalSales",
                        err.toString(),
                        "toGetTotalSales",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return totalPrice;
            },

            async getSysAgentSales() {
                if (BaseConfiguration.isDebug) console.log("getSysAgentSales");
                let returnValue;

                try {
                    if (this.selPeriod) {
                        let agentSalesReq = apiAgentSales.buildRequest(this.selPeriod); //constant

                        if (agentSalesReq != null) {
                            let agentSalesRes = await apiAgentSales.getResponse(
                                agentSalesReq
                            );
                            if (VALIDATE_SUCCESS_RES(agentSalesRes)) {
                                returnValue = agentSalesRes.data.data;

                            } else {
                                let error = getErrorMessage(agentSalesRes);

                                let isJwt = handleJWT(error);
                                if (!isJwt) {
                                    this.showAlert(getErrorAlertValue(error));
                                }
                            }
                        } else {
                            throw "invalid request";
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_SYS_AGENT_SALES,
                        "error in  getSysAgentSales",
                        err.toString(),
                        "getSysAgentSales()",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },
        }
    }

</script>
<style>
    main.c-main {
        background: #f2f4f5;
    }
</style>